module.exports = __webpack_public_path__ + "fo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/fo.svg
// module id = 549
// module chunks = 0